import { Link, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { CreateAccountOkResponse } from 'api/ErplySignupApi.types';

const dev = {
  ClientCode: 'string',
  Username: 'string',

  SessionKey: 'string',
  Password: 'string',
  UserID: 'string',
  EmployeeID: 'string',
};

const Layout = styled.div`
  width: 100%;
  height: 100%;

  display: grid;
  min-width: 0;
  min-height: 0;
  grid-template-columns: 1fr 1fr;
  align-content: center;

  padding: 3rem;

  ${({
    theme: {
      breakpoints,
      palette: {
        primary: { main },
      },
    },
  }) => css`
    > h3 {
      flex-grow: 1;
      padding: 4rem 1rem;
      border-right: 2px solid ${main};

      ${breakpoints.down('md')} {
        border-bottom: 2px solid ${main};
        border-right: none;
        font-size: 2.5em;
      }
      ${breakpoints.down('sm')} {
        font-size: 2em;
      }
    }

    > div {
      flex-grow: 1;

      padding: 4rem 1rem;
    }

    ${breakpoints.down('md')} {
      grid-template-columns: 1fr;
    }

    ${breakpoints.down('sm')} {
      padding: 1rem;
    }
    a {
      font-size: inherit;
      line-height: inherit;
      font-weight: inherit;
    }
  `}
`;

const Final: React.FC = () => {
  const { t } = useTranslation();
  const { state = process.env.NODE_ENV === 'development' ? dev : undefined } =
    useLocation<CreateAccountOkResponse>();
  const history = useHistory();

  if (state === undefined) {
    history.push('/');
    return null;
  }

  return (
    <Layout>
      <Typography variant="h3">{t('final.thankYou1')}</Typography>
      <div>
        <p>
          <Typography variant="h5">
            <strong>{t('final.clientCode')}:</strong> {state.ClientCode}
          </Typography>
          <Typography variant="h5">
            <strong>{t('final.username')}:</strong> {state.Username}
          </Typography>
        </p>
        <p>
          <Typography variant="h5">
            {t('final.erply.login')}{' '}
            <Link
              target="_blank"
              rel="noreferrer noopener"
              href="https://login.erply.com"
            >
              {t('final.here')}
            </Link>
          </Typography>
        </p>
      </div>
    </Layout>
  );
};

export default Final;
